import { useTranslations } from "../../lib/translations"
import { useStore } from "../../stores/store"
import { canvasStore, openNewAgentModal } from "../../stores/canvasStore"

export function AddZone() {
  const t = useTranslations()
  const agents = useStore(canvasStore, (s) => s.agents)

  const onClick = () => {
    const builder = agents.find((a) => a.role === "agent-builder")
    if (builder) {
      openNewAgentModal()
    } else {
      alert(t("canvas.add.no_builder"))
    }
  }

  return (
    <div className="cm-addzone" onClick={onClick} title={t("canvas.add.label")}>
      <svg viewBox="0 0 24 24"><path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6V5z" /></svg>
      <small>{t("canvas.add.label")}</small>
    </div>
  )
}
